import React, {useState, useEffect }  from 'react';
import {ToasterProvider, useToaster} from "../../../global-components/toaster.jsx";
import {__, _nonce, _solea_get_local_groups} from '../../../../../assets/javascripts/library.js';
import ReactDOM from "react-dom/client";
import Modal from "../../../global-components/modal.jsx";
import Settings from "../settings.jsx";

function ShowOrEditGroupBasedFees({event}) {
    const [noAmount, setNoAmount] = useState(false);
    const [formData, setFormData] = useState({
        id: event.id || 0,
        amount_team: event.edit.amount_team || __('Keep free to ignore', 'solea'),
        amount_volunteer: event.edit.amount_volunteer || __('Keep free to ignore', 'solea'),
        amount_participant: event.edit.amount_participant || '',
        amount_other: event.edit.amount_other || __('Keep free to ignore', 'solea'),
        description_other: event.edit.description_other || '',
        description_team: event.edit.description_team || '',
        description_volunteer: event.edit.description_volunteer|| '',
        description_participant: event.edit.description_participant || '',

    });

    const returnToSettings = () => {
        const response = fetch("/wp-json/solea/event-details/print-page/settings", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                        <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        if (!event.editable) return;

        if ('' === formData.amount_participant ) {
            setNoAmount(true);
            return;
        }


        const response = fetch("/wp-json/solea/event-details/print-page/payment-fees/save/groupbased", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                formData,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                            <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    const css_class = event.editable ? 'solea-participation-fees-table-editable' : 'solea-participation-fees-table-readonly';


    return (
        <div>
            <table  class={css_class}>
                <tr>
                    <td>
                        <label>
                            {__('Amount for participants', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_participant}
                            name="amount_participant"
                            onChange={handleChange}
                        /> {__('Euro', 'solea')} / {__('day', 'solea')}
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={event.edit.description_participant}
                            name="description_participant"
                            onChange={handleChange}
                        />
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>
                            {__('Amount for teamers', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_team}
                            name="amount_team"
                            onChange={handleChange}
                        /> {__('Euro', 'solea')} / {__('day', 'solea')}
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={event.edit.description_team}
                            name="description_team"
                            onChange={handleChange}
                        />
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>
                            {__('Amount for other volunteers', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_volunteer}
                            name="amount_volunteer"
                            onChange={handleChange}
                        /> {__('Euro', 'solea')} / {__('day', 'solea')}
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={event.edit.description_volunteer}
                            name="description_volunteer"
                            onChange={handleChange}
                        />
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>
                            {__('Amount for others', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_other}
                            name="amount_other"
                            onChange={handleChange}
                        /> {__('Euro', 'solea')} / {__('day', 'solea')}
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={event.edit.description_other}
                            name="description_other"
                            onChange={handleChange}
                        />
                    </td>
                </tr>
            </table>
            <p>
                {
                    event.editable ? (
                        <button onClick={handleSubmit} class="button solea-button mr-10">{__('Save payment details', 'solea')}</button>
                    ) : ('')
                }
                {
                    event.edit.amount_participant != null ? (
                        <button onClick={returnToSettings} className="button solea-button cancel">{__('Return', 'solea')}</button>
                    ) : ('')
                }
            </p>

            <Modal title={__('No participant amount specified', 'solea')} isOpen={noAmount} onClose={() => setNoAmount(false)}>
                <p>
                    {__('You have to declare at least the participation fee for participants. If the event is free of charge, please enter "0,00" as amount.', 'solea')}
                </p>
            </Modal>
        </div>
    )
}

export default ShowOrEditGroupBasedFees;